export function randomInt(min, max) {
    // @ts-ignore
    return Math.floor(Math.random() * (max - min + 1) + min)
  }